module.exports = __webpack_public_path__ + "static/media/baby_octo_alpha_0001.ef088e2a.png";